import type { ObservabilityExchange, ObservabilityList } from '@/features/observability/model/types';

const STORE = "L'Occitane au Brésil";

const webengageUser = {
  userId: '40015264840',
  firstName: 'Ana',
  lastName: 'Maria Souza',
  email: 'ana.souza@example.com',
  phone: '19992521038',
  emailOptIn: true,
  smsOptIn: true,
  whatsappOptIn: false,
  attributes: {
    tierLoyalty: 'Privilège',
    pontosLoyalty: 900,
    dataAtualizacaoLoyalty: '2026-10-14T18:02:11.000Z',
    walletLoyalty: true,
  },
};

const terceiro = {
  nome: 'Ana Maria Souza',
  documento: '40015264840',
  emails: ['ana.souza@example.com'],
  dataNascimento: '10-02-1990',
  telefones: [{ ddi: 55, ddd: 19, numero: '992521038', tipoTelefone: 'CELULAR' }],
  autorizaReceberEmail: true,
  autorizaReceberSms: true,
  autorizaReceberWhatsapp: false,
  participaProgramaFidelidade: true,
  ativo: true,
};

const created = { idRecurso: 48120, codigoMensagem: 0, mensagem: 'Operação realizada com sucesso.' };

/** Trocas de exemplo. A lista real ainda não existe na API. */
export const OBSERVABILITY_ROWS: ObservabilityExchange[] = [
  {
    id: 'vo-post',
    at: '2026-10-14T18:40:12.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'varejonline',
    direction: 'outbound',
    event: 'POST /terceiros',
    httpStatus: 201,
    status: 'success',
    sent: terceiro,
    received: created,
  },
  {
    id: 'vo-put',
    at: '2026-10-14T19:05:44.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'varejonline',
    direction: 'outbound',
    event: 'PUT /terceiros',
    httpStatus: 201,
    status: 'success',
    sent: { ...terceiro, emails: ['ana.nova@example.com'], autorizaReceberEmail: false },
    received: { idRecurso: 48120, codigoMensagem: 0, mensagem: 'Operação realizada com sucesso.' },
  },
  {
    id: 'vo-skip',
    at: '2026-10-14T19:06:02.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'varejonline',
    direction: 'outbound',
    event: 'PUT /terceiros (sem mudança)',
    httpStatus: null,
    status: 'skipped',
    note: 'Fixe → Varejo Online. O cadastro não mudou; a API não foi chamada.',
    sent: { ...terceiro, emails: ['ana.nova@example.com'], autorizaReceberEmail: false },
    received: null,
  },
  {
    id: 'vo-400',
    at: '2026-10-14T17:12:33.000Z',
    storeName: STORE,
    personName: 'Bruno Lima',
    personDocumentMasked: '***.***.***-00',
    provider: 'varejonline',
    direction: 'outbound',
    event: 'POST /terceiros',
    httpStatus: 400,
    status: 'failed',
    sent: { ...terceiro, nome: 'Bruno Lima', documento: '12345678900', emails: ['bruno.lima@example.com'] },
    received: { idRecurso: 0, codigoMensagem: 1, mensagem: 'Terceiro com documento inválido' },
  },
  {
    id: 'vo-pending',
    at: '2026-10-14T20:01:18.000Z',
    storeName: STORE,
    personName: 'Clara Nunes',
    personDocumentMasked: '***.***.***-25',
    provider: 'varejonline',
    direction: 'outbound',
    event: 'POST /terceiros',
    httpStatus: null,
    status: 'pending',
    note: 'Na fila. Fixe → Varejo Online. Vai ser POST /terceiros.',
    sent: { ...terceiro, nome: 'Clara Nunes', documento: '52998224725', emails: ['clara.nunes@example.com'] },
    received: null,
  },
  {
    id: 'vo-in-created',
    at: '2026-10-13T15:22:09.000Z',
    storeName: STORE,
    personName: 'Diego Alves',
    personDocumentMasked: '***.***.***-04',
    provider: 'varejonline',
    direction: 'inbound',
    event: 'Webhook recebido',
    httpStatus: 201,
    status: 'success',
    note: 'O Varejo Online avisou a Fixe. A Fixe buscou o terceiro e criou o cliente.',
    received: {
      webhook: { contractId: 'loc-001', object: 'https://integrador.varejonline.com.br/apps/api/terceiros/90211' },
      terceiro: {
        nome: 'Diego Alves',
        documento: '58956670404',
        emails: ['diego.alves@example.com'],
        tipoPessoa: 'PF',
        categoria: 'FIXECRM',
        ativo: true,
      },
    },
    sent: { status: 201, message: 'Cliente criado.' },
  },
  {
    id: 'vo-in-exists',
    at: '2026-10-13T16:02:41.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'varejonline',
    direction: 'inbound',
    event: 'Webhook recebido',
    httpStatus: 201,
    status: 'success',
    note: 'O terceiro já era cliente nesta loja. A Fixe não criou outro.',
    received: {
      webhook: { contractId: 'loc-001', object: 'https://integrador.varejonline.com.br/apps/api/terceiros/48120' },
      terceiro: { nome: 'Ana Maria Souza', documento: '40015264840', tipoPessoa: 'PF', categoria: 'FIXECRM', ativo: true },
    },
    sent: { status: 201, message: 'Cliente já existia.' },
  },
  {
    id: 'vo-in-rejected',
    at: '2026-10-12T11:18:55.000Z',
    storeName: STORE,
    personName: 'Oficina Sul Ltda',
    personDocumentMasked: '**.***.***/****-10',
    provider: 'varejonline',
    direction: 'inbound',
    event: 'Webhook recebido',
    httpStatus: 201,
    status: 'failed',
    note: 'A Fixe só cria pessoa física ativa na categoria FIXECRM.',
    received: {
      webhook: { contractId: 'loc-001', object: 'https://integrador.varejonline.com.br/apps/api/terceiros/77' },
      terceiro: { nome: 'Oficina Sul Ltda', documento: '12345678000110', tipoPessoa: 'PJ', categoria: 'FORNECEDOR', ativo: true },
    },
    sent: { status: 201, message: 'Cliente não é pessoa física ou não está ativo.' },
  },
  {
    id: 'we-created',
    at: '2026-10-14T18:40:13.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'webengage',
    direction: 'outbound',
    event: 'POST /terceiros',
    httpStatus: 201,
    status: 'success',
    note: 'O WebEngage não envia webhook. O que voltou é a resposta do POST /users.',
    sent: webengageUser,
    received: { response: { status: 'queued' } },
  },
  {
    id: 'we-profile',
    at: '2026-10-14T19:05:45.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'webengage',
    direction: 'outbound',
    event: 'PUT /terceiros',
    httpStatus: 201,
    status: 'success',
    note: 'O WebEngage não envia webhook. O que voltou é a resposta do POST /users.',
    sent: { ...webengageUser, email: 'ana.nova@example.com', emailOptIn: false },
    received: { response: { status: 'queued' } },
  },
  {
    id: 'we-points',
    at: '2026-10-14T12:16:08.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'webengage',
    direction: 'outbound',
    event: 'Pontos',
    httpStatus: 201,
    status: 'success',
    note: 'O WebEngage não envia webhook. O que voltou é a resposta do POST /users.',
    sent: {
      ...webengageUser,
      attributes: { ...webengageUser.attributes, pontosLoyalty: 1400, tierLoyalty: 'Privilège' },
    },
    received: { response: { status: 'queued' } },
  },
  {
    id: 'we-tier',
    at: '2026-10-14T12:16:09.000Z',
    storeName: STORE,
    personName: 'Ana Maria Souza',
    personDocumentMasked: '***.***.***-40',
    provider: 'webengage',
    direction: 'outbound',
    event: 'Tier',
    httpStatus: 201,
    status: 'success',
    note: 'O WebEngage não envia webhook. O que voltou é a resposta do POST /events.',
    sent: {
      userId: '40015264840',
      eventName: 'TierUpdate',
      eventTime: '2026-10-14T09:16:09-0300',
      eventData: { newTier: 'Privilège', lastTier: 'Invité', updateTierDate: '2026-10-14T12:16:09.000Z' },
    },
    received: { response: { status: 'queued' } },
  },
  {
    id: 'we-wallet',
    at: '2026-10-11T09:44:27.000Z',
    storeName: STORE,
    personName: 'Elena Costa',
    personDocumentMasked: '***.***.***-08',
    provider: 'webengage',
    direction: 'outbound',
    event: 'Carteira',
    httpStatus: 201,
    status: 'success',
    note: 'O WebEngage não envia webhook. O que voltou é a resposta do POST /users.',
    sent: {
      ...webengageUser,
      userId: '39053344705',
      firstName: 'Elena',
      lastName: 'Costa',
      email: 'elena.costa@example.com',
      attributes: { ...webengageUser.attributes, walletLoyalty: true, tierLoyalty: 'Invité', pontosLoyalty: 120 },
    },
    received: { response: { status: 'queued' } },
  },
];

export function queryObservability(params: URLSearchParams): ObservabilityList {
  const provider = params.get('provider') || 'all';
  const direction = params.get('direction') || 'all';
  const status = params.get('status') || 'all';
  const q = (params.get('q') || '').trim().toLowerCase();

  const base = OBSERVABILITY_ROWS.filter((row) => {
    if (provider !== 'all' && row.provider !== provider) return false;
    if (direction !== 'all' && row.direction !== direction) return false;
    if (q && !row.personName.toLowerCase().includes(q)) return false;
    return true;
  }).sort((a, b) => (a.at < b.at ? 1 : -1));

  const counts = {
    success: base.filter((row) => row.status === 'success').length,
    failed: base.filter((row) => row.status === 'failed').length,
    pending: base.filter((row) => row.status === 'pending').length,
  };
  const rows = status === 'all' ? base : base.filter((row) => row.status === status);
  return { rows, counts };
}

export interface ObservabilityRetention {
  enabled: boolean;
  intervalDays: number;
  lastRunAt: string | null;
  lastDeleted: number;
}

let retention: ObservabilityRetention = {
  enabled: true,
  intervalDays: 15,
  lastRunAt: null,
  lastDeleted: 0,
};

export function getObservabilityRetention(): ObservabilityRetention {
  return retention;
}

export function saveObservabilityRetention(body: { enabled?: boolean; intervalDays?: number }): ObservabilityRetention | null {
  const days = Number(body.intervalDays);
  if (!Number.isInteger(days) || days < 1 || days > 365) return null;
  retention = {
    ...retention,
    enabled: body.enabled === true,
    intervalDays: days,
  };
  return retention;
}
